import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Schedule from "pages/Schedule";
import Classes from "pages/Classes";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import Massage from "pages/Massage";
import ScrollToTop from "utils/ScrollToTop";

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop /> {/* Add ScrollToTop here */}
      <div className="flex flex-col min-h-screen bg-gray-100">
        <Navigation />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/boka" element={<Booking />} />
            <Route path="/schema" element={<Schedule />} />
            <Route path="/klasser" element={<Classes />} />
            <Route path="/massage" element={<Massage />} />
            <Route path="/omoss" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
